module.exports = __webpack_public_path__ + "static/media/Azir.baf32ee9.png";